import styles from './FilterControls.module.css';
import Slider from "../Slider/Slider";
import { useFilterControls } from '../../hooks/useFilterControls';

const FILTER_TYPES = [
    { value: 'NONE', label: 'None' },
    { value: 'SVF', label: 'SVF' },
    { value: 'LADDER', label: 'Ladder' },
];

export default function FilterControls({ sendCommand }) {
    const {
        filterType,
        cutoffSlider,
        cutoffActual,
        resonanceSlider,
        resonanceActual,
        handleFilterTypeChange,
        handleCutoffChange,
        handleResonanceChange
    } = useFilterControls(sendCommand);
    const isFilterEnabled = filterType !== 'NONE';

    return (
        <div className={styles.section}>
            <div className={styles.container}>
                <h2 className={styles.header}>Filter</h2>
                <div className={styles.controlsFrame}>
                <div className={styles.row}>
                    <span className={styles.label}>Type</span>
                    <div className={styles.buttonGroup}>
                        {FILTER_TYPES.map(({ value, label }) => (
                            <button
                                key={value}
                                className={`${styles.button} ${filterType === value ? styles.active : ''}`}
                                onClick={() => handleFilterTypeChange(value)}
                            >
                                {label}
                            </button>
                        ))}
                    </div>
                </div>

                <div className={isFilterEnabled ? '' : styles.disabled}>
                    <Slider
                        label="Cutoff"
                        value={cutoffSlider}
                        onChange={handleCutoffChange}
                        displayValue={`${cutoffActual.toFixed(0)} Hz`}
                        disabled={!isFilterEnabled}
                    />
                    <Slider
                        label="Resonance"
                        value={resonanceSlider}
                        onChange={handleResonanceChange}
                        displayValue={resonanceActual.toFixed(2)}
                        disabled={!isFilterEnabled}
                    />
                </div>
                </div>
            </div>
        </div>
    );
}
